import { Recipe } from "../interfaces/interfaces";

// ── Recipes data ───────────────────────────────────────────────────────────────
export const RECIPES: Record<string, Recipe> = {
    "chicken-pineapple": {
        tags: ["airfryer", "chicken", "mainDish"],
        title: "Курица с ананасом и сыром",
        desc: "Куриное филе запекается до золотистой корочки, сверху — кольцо ананаса и расплавленный сыр.",
        time: "25–30 мин",
        temp: "180–200°C",
        servings: "2 порции",
        ingredients: [
            { name: "Куриное филе (грудка)", amount: "350–400 г" },
            { name: "Ананас консервированный", amount: "100–150 г" },
            { name: "Сыр твёрдый", amount: "80–100 г" },
            { name: "Майонез или сметана", amount: "2–3 ст. л." },
            { name: "Соль, перец, приправа для курицы", amount: "по вкусу" },
        ],
        steps: [
            "Филе промойте и обсушите. Разрежьте каждую грудку вдоль на 2–3 плоские части.",
            "Посолите, поперчите, добавьте приправу и майонез. Оставьте мариноваться 15–20 минут.",
            "Выложите курицу на решётку аэрогриля. Готовьте при 180–200°C 15 минут на средней скорости обдува.",
            "Достаньте решётку. На каждый кусок выложите кольцо ананаса, обильно посыпьте тёртым сыром.",
            "Верните в аэрогриль ещё на 10–15 минут — до румяной сырной корочки.",
        ],
        tips: [
            "Консервированные ананасы дают больше сока, который пропитывает мясо.",
            "Для тягучести смешайте твёрдый сыр с моцареллой.",
            "Для плотной корочки обваляйте филе в муке с паприкой и чесноком перед первым этапом.",
            "Подавать с рисом, картофельным пюре или свежими овощами. ~265 ккал на 100 г.",
        ],
    },
    crackers: {
        tags: ["airfryer", "snack"],
        title: "Сухарики домашние",
        desc: "Хрустящие сухарики из батона с маслом и специями. Варианты: с соевым соусом, горчицей зернистой, чесноком и зеленью.",
        time: "5–7 мин",
        temp: "160–180°C",
        servings: "снэк",
        ingredients: [
            { name: "Батон (кубики 1–1,5 см)", amount: "½ батона" },
            { name: "Растительное масло", amount: "1–2 ст. л." },
            { name: "Чеснок (гранулированный)", amount: "0,5 ч. л." },
            { name: "Специи: паприка, укроп, перец", amount: "по вкусу" },
        ],
        steps: [
            "Нарежьте батон кубиками 1–1,5 см и сложите в плотный пакет.",
            "Смешайте масло со специями. Разогрейте в микроволновке 20 сек, дайте настояться 5 мин.",
            "Залейте смесь в пакет с кубиками, плотно закройте и хорошо встряхните.",
            "Высыпьте в корзину аэрогриля. Готовьте при 160–180°C 5–7 минут, встряхивая каждые 2 минуты.",
        ],
        tips: [
            "Мельче 1 см — сгорят. Крупнее 1,5 см — внутри останутся мягкими.",
            "Соевый соус: 1 ст. л. + 1 ст. л. масла — пикантные, с умами-ноткой. Не добавляйте соль.",
            "Зернистая горчица: 1 ч. л. + 1 ст. л. масла — пикантный кисловатый вкус.",
            "Идеальный микс: 0,5 ст. л. соевого + 0,5 ч. л. горчицы + 1 ст. л. масла.",
            "Сыр (тёртый пармезан) добавляйте за 2 минуты до готовности.",
        ],
    },
    cheesecake: {
        tags: ["airfryer", "dessert"],
        title: "Чизкейк творожно-сырный",
        desc: "Нежный чизкейк на основе из печенья со сливочным сыром, творогом и сгущёнкой.",
        time: "40–45 мин",
        temp: "160°C",
        servings: "форма ~1 л",
        ingredients: [
            { name: "Печенье «Деревенское»", amount: "150 г" },
            { name: "Масло сливочное 72,5%", amount: "75 г" },
            { name: "Сливочный сыр (Хохланд)", amount: "200 г" },
            { name: "Творог 1,8%", amount: "150 г" },
            { name: "Сгущёнка", amount: "100 г (~3–4 ст. л.)" },
            { name: "Яйцо", amount: "1 шт." },
        ],
        steps: [
            "Форму смажьте маслом или застелите дно пергаментом. Достаньте сыр и творог за 30 мин до готовки.",
            "Печенье раздавите в крошку. Смешайте с растопленным маслом до «влажного песка». Утрамбуйте в форму, уберите в холодильник на 15–20 мин.",
            "Творог + сгущёнку пробейте погружным блендером до гладкой пасты. Добавьте мягкий сыр, перемешайте ложкой. Вбейте яйцо, перемешайте.",
            "Вылейте начинку на корж. Разровняйте, постучите формой о стол 2–3 раза.",
            "Готовьте при 160°C 40–45 мин. Края плотные, центр чуть колышется как желе — готово.",
            "Выключите аэрогриль, приоткройте крышку. Остужайте внутри 20 мин, затем при комнатной температуре 1,5–2 ч.",
            "Накройте плёнкой и уберите в холодильник минимум на 6 часов, лучше на ночь.",
        ],
        tips: [
            "Корж + начинка не должны превышать ~700 мл — иначе вытечет при запекании.",
            "Творог обязательно пробивать до гладкости, иначе будут крупинки.",
            "Если центр тянется после охлаждения — добавьте 1 ст. л. кукурузного крахмала в начинку.",
            "Остатки печенья покрошите и посыпьте готовый чизкейк перед подачей.",
        ],
    },
    "fried-rice": {
        tags: ["pan", "mainDish"],
        title: "Жареный рис с мясом и овощами",
        desc: "Быстрый ужин в азиатском стиле: замороженная смесь рис+овощи, мясо или креветки, соевый соус и терияки.",
        time: "15 мин",
        temp: "Сильный огонь",
        servings: "1–2 порции",
        ingredients: [
            { name: "Замороженная смесь рис+овощи", amount: "1 упаковка" },
            { name: "Мясо (курица/свинина/говядина) или креветки", amount: "200–300 г" },
            { name: "Соевый соус", amount: "3 ст. л." },
            { name: "Соус терияки", amount: "2–3 ст. л." },
            { name: "Чеснок", amount: "2 зубчика" },
            { name: "Растительное масло", amount: "для жарки" },
            { name: "Финская соль", amount: "щепотка в конце" },
        ],
        steps: [
            "Мясо нарежьте тонкими полосками (2–3 см, толщина ~1 см). Чеснок мелко порубите.",
            "Сковорода очень горячая + масло. Выложите мясо в один слой. Не мешайте 1–2 мин — дайте схватиться корочке. Переверните, ещё 1–2 мин.",
            "Снимите мясо в тарелку. На ту же сковороду добавьте масла при необходимости.",
            "Высыпьте замороженную смесь, жарьте 5–7 мин, постоянно помешивая. Добавьте чеснок, жарьте 30 сек.",
            "Влейте соевый соус и терияки, перемешайте, прогрейте 1 мин. Верните мясо, прогрейте 30–60 сек.",
            "Попробуйте. Если не хватает солёности — щепотка финской соли. Подавать сразу горячим.",
        ],
        tips: [
            "Курица: можно предварительно замариновать в 1 ст. л. соевого + специи на 5 мин.",
            "Говядина: режьте очень тонко, жарьте не дольше 3–4 мин — иначе станет жёсткой.",
            "Для креветок: разморозьте в холодной воде 5 мин, обсушите. Жарьте 1–2 мин с каждой стороны.",
            "Появление лёгких «пригаринок» на рисе — это тот самый вкус вока, это хорошо.",
        ],
    },

    "ice-cream": {
        tags: ["blender", "dessert"],
        title: "Мороженое за 1 минуту",
        desc: "Кремовое домашнее мороженое из замороженных ягод, банана, сливок и сгущёнки. С желатином для плотной текстуры.",
        time: "10 мин + 30–40 мин заморозка",
        servings: "2–3 порции",
        ingredients: [
            { name: "Замороженные ягоды", amount: "250 г" },
            { name: "Замороженный банан (кружки)", amount: "50 г" },
            { name: "Сливки 33%", amount: "180 г" },
            { name: "Сгущёнка", amount: "60–80 г" },
            { name: "Желатин (порошок)", amount: "2 г" },
            { name: "Лимонный сок", amount: "1 ч. л." },
            { name: "Ванилин", amount: "на кончике ножа" },
            { name: "Соль мелкая", amount: "1 щепотка" },
        ],
        steps: [
            "За 10 мин до старта: залейте 2 г желатина 2 ст. л. холодной воды, дайте набухнуть.",
            "Нагрейте желатин в микроволновке 5–7 сек до жидкого состояния (не кипятить!). Остудите до комнатной температуры.",
            "В чашу блендера: ягоды, банан, сливки, сгущёнку (начните с 60 г), лимонный сок, ванилин, соль и остывший желатин.",
            "Взбивайте на максимуме ровно 25–30 сек до однородной воздушной массы. Дольше — масса нагреется и растает.",
            "Попробуйте: не хватает сладости — добавьте сгущёнку, взбейте 5 сек. Слишком сладко — лимонный сок.",
            "Переложите в контейнер, разровняйте. Уберите в морозилку на 30–40 мин.",
        ],
        tips: [
            "Банан отвечает за кремовость — не пропускайте. Без него текстура будет более ледяной.",
            "Щепотка соли подчёркивает ягоды и сглаживает сладость.",
            "Блендер менее 700 Вт: дайте ягодам слегка подтаять 5 мин перед взбиванием.",
            "Хранение: до 3 дней в морозилке. Перед подачей подержать 5–7 мин при комнатной температуре.",
        ],
    },

    marinade: {
        tags: ["marinade", "sauce"],
        title: "Маринад мёд-соя-имбирь",
        desc: "Универсальный азиатский маринад для курицы, свинины, говядины и рыбы. Три вариации: острая, цитрусовая, с луком.",
        time: "30 мин – 24 ч",
        servings: "500–700 г мяса",
        ingredients: [
            { name: "Соевый соус", amount: "4 ст. л." },
            { name: "Мёд (жидкий)", amount: "1–2 ст. л." },
            { name: "Чеснок", amount: "2–3 зубчика" },
            { name: "Имбирь свежий (тёртый)", amount: "~3 см корня" },
            { name: "Растительное масло", amount: "1 ст. л." },
            { name: "Кунжутное масло (опционально)", amount: "1 ч. л." },
        ],
        steps: [
            "Смешайте все ингредиенты. Если мёд засахарился — слегка растопите. Чеснок выдавите через пресс.",
            "Залейте маринадом мясо. Время: рыба 15–30 мин; куриное филе 30 мин – 2 ч; куриные бёдра/свинина 2–4 ч; говядина/баранина 4–24 ч.",
            "При жарке на сковороде: сначала обжарьте мясо без маринада до корочки, затем влейте маринад, убавьте огонь и выпаривайте до глазури.",
            "При запекании в аэрогриле: готовьте под фольгой 20–30 мин, снимите фольгу, полейте остатками маринада, включите режим гриль на 5–7 мин.",
        ],
        tips: [
            "Мёд горит быстро — не держите на сильном огне без наблюдения.",
            "Острый вариант: добавьте 1 ч. л. пасты Gochujang или хлопьев чили.",
            "Цитрусовый вариант: добавьте цедру апельсина и сок половины лимона/лайма.",
            "С луком: добавьте 1 тёртую луковицу — ферменты делают мясо мягким.",
        ],
    },

    udon: {
        tags: ["pan", "chicken", "mainDish"],
        title: "Удон с курицей и овощами",
        desc: "Классический яки-удон с золотистой курицей, морковью, перцем и соусом терияки. Готовится за 30 минут.",
        time: "30 мин",
        temp: "Сильный огонь",
        servings: "2 порции",
        ingredients: [
            { name: "Лапша удон", amount: "250–300 г" },
            { name: "Куриное филе", amount: "200–500 г" },
            { name: "Морковь", amount: "1 шт." },
            { name: "Болгарский перец", amount: "1 шт." },
            { name: "Репчатый лук", amount: "1 шт." },
            { name: "Чеснок", amount: "2–3 зубчика" },
            { name: "Соевый соус", amount: "2–4 ст. л." },
            { name: "Соус терияки", amount: "2–4 ст. л." },
            { name: "Растительное масло", amount: "2–3 ст. л." },
            { name: "Кунжут, зелёный лук", amount: "для подачи" },
        ],
        steps: [
            "Отварите удон по инструкции (3–10 мин). Откиньте на дуршлаг, промойте холодной водой, сбрызните маслом.",
            "Нарежьте курицу и овощи (кроме чеснока) тонкой соломкой. Чеснок измельчите.",
            "В раскалённой сковороде или воке обжаривайте курицу на сильном огне 5–7 мин до золотистой корочки.",
            "Добавьте лук, морковь и перец. Готовьте, помешивая, ещё 3–5 минут.",
            "Добавьте чеснок, влейте соевый соус и терияки. Готовьте 1–2 минуты.",
            "Выложите лапшу, быстро перемешайте и прогревайте на сильном огне 1–2 минуты.",
            "Посыпьте кунжутом и зелёным луком. Подавать горячим или холодным.",
        ],
        tips: [
            "Не промытая лапша прилипнет к сковороде — промывка холодной водой обязательна.",
            "Для более насыщенного вкуса добавьте 1 ч. л. кунжутного масла в конце.",
            "Вариации: яки-удон с морепродуктами, вегетарианский с грибами и тофу.",
        ],
    },

    "mulled-juice": {
        tags: ["drink"],
        title: "Безалкогольный глинтвейн",
        desc: "Согревающий ароматный напиток на виноградном или яблочном соке со специями.",
        time: "20–25 мин",
        servings: "4 кружки (~1 л)",
        ingredients: [
            { name: "Виноградный или яблочный сок (или 50/50)", amount: "1 л" },
            { name: "Апельсин", amount: "1 шт." },
            { name: "Лимон", amount: "½ шт." },
            { name: "Корица", amount: "1 палочка" },
            { name: "Гвоздика", amount: "3–4 бутона" },
            { name: "Кардамон", amount: "2 коробочки" },
            { name: "Имбирь свежий", amount: "кусочек ~1 см" },
            { name: "Мёд или сахар", amount: "по вкусу" },
            { name: "Бадьян, сушёная клюква (по желанию)", amount: "по вкусу" },
        ],
        steps: [
            "Нарежьте апельсин и лимон кружками. Имбирь нарежьте тонкими пластинками.",
            "В кастрюле смешайте сок, фрукты и специи. Добавьте 1–2 ст. л. мёда или сахара.",
            "Нагревайте на медленном огне, не доводя до кипения (70–80°C), пока не появится лёгкий пар.",
            "Выключите, накройте крышкой и настаивайте 10–15 минут.",
            "Процедите и разлейте по кружкам.",
        ],
        tips: [
            "Сок слаще вина — пробуйте на сладость и добавляйте сахар/мёд осторожно.",
            "Добавьте 1 ч. л. лимонного сока для лёгкой кислинки.",
            "Украсьте палочкой корицы или долькой апельсина при подаче.",
        ],
    },

    "mapo-tofu": {
        tags: ["pan", "tofu", "mainDish"],
        title: "Мапо тофу (с простыми заменами)",
        desc: "Острое китайское блюдо с тофу и мясным фаршем в пряном соусе. Адаптировано под доступные ингредиенты.",
        time: "20–25 мин",
        servings: "2–3 порции",
        ingredients: [
            { name: "Тофу твёрдый", amount: "300–400 г" },
            { name: "Мясной фарш (свинина или говядина)", amount: "200 г" },
            { name: "Томатная паста или кетчуп", amount: "2 ст. л." },
            { name: "Соевый соус", amount: "3 ст. л." },
            { name: "Красный молотый перец", amount: "½ ч. л." },
            { name: "Куриный бульон", amount: "250 мл" },
            { name: "Кукурузный крахмал", amount: "2 ст. л." },
            { name: "Сахар (коричневый или белый)", amount: "1 ст. л." },
            { name: "Чеснок", amount: "3–4 зубчика" },
            { name: "Имбирь свежий (тёртый)", amount: "~2 см корня" },
            { name: "Растительное масло", amount: "2 ст. л." },
            { name: "Кунжутное масло (по желанию)", amount: "1 ч. л." },
            { name: "Зелёный лук", amount: "для подачи" },
        ],
        steps: [
            "Тофу нарежьте кубиками ~1 см. Бланшируйте в кипящей воде 2 минуты, аккуратно слейте.",
            "Острая паста: смешайте томатную пасту, 1 ст. л. соевого соуса и красный перец.",
            "Соус: разведите крахмал в 3 ст. л. холодной воды, смешайте с бульоном, оставшимся соевым соусом, сахаром, чесноком и имбирём.",
            "Обжарьте фарш в масле до изменения цвета.",
            "Добавьте острую пасту к фаршу, хорошо перемешайте.",
            "Влейте соус, доведите до кипения. Аккуратно выложите тофу и тушите 2–3 минуты.",
            "При подаче добавьте кунжутное масло и посыпьте зелёным луком. Подавать с рисом.",
        ],
        tips: [
            "Крахмал всегда разводите сначала в холодной воде, иначе образуются комки.",
            "Не перемешивайте тофу слишком активно — кубики легко ломаются.",
            "Хотите острее — добавьте больше перца или хлопья чили.",
        ],
    },

    "tofu-classic": {
        tags: ["airfryer", "tofu", "snack"],
        title: "Хрустящий тофу (классический)",
        desc: "Хрустящий снаружи, мягкий внутри тофу с соевым соусом и специями.",
        time: "12–20 мин",
        temp: "190–200°C",
        servings: "2 порции",
        ingredients: [
            { name: "Тофу твёрдый (extra firm)", amount: "250–450 г" },
            { name: "Кукурузный крахмал", amount: "1–2 ст. л." },
            { name: "Соевый соус", amount: "2 ст. л." },
            { name: "Кунжутное масло", amount: "1 ч. л. (по желанию)" },
            { name: "Паприка, чесночный порошок", amount: "по вкусу" },
        ],
        steps: [
            "Тофу отпрессуйте 15–30 мин: заверните в бумажное полотенце, поставьте груз. Нарежьте кубиками.",
            "Смешайте с соевым соусом, маслом и специями.",
            "Обваляйте в крахмале.",
            "Выложите в один слой в корзину аэрогриля. Готовьте при 190–200°C 12–20 мин, встряхнув корзину на середине.",
        ],
        tips: [
            "Отжим влаги — ключ к хрусту. Без него тофу будет мягким.",
            "Раскладывайте на расстоянии — не слоями.",
            "Тофу берите только твёрдый (extra firm).",
        ],
    },

    "tofu-nuggets": {
        tags: ["airfryer", "tofu", "snack"],
        title: "Тофу-наггетсы",
        desc: "Тофу, напоминающий куриные наггетсы — с пищевыми дрожжами для сырного вкуса.",
        time: "12–14 мин",
        temp: "200°C",
        servings: "2 порции",
        ingredients: [
            { name: "Тофу твёрдый", amount: "400 г" },
            { name: "Кукурузный крахмал", amount: "2,5 ст. л." },
            { name: "Соевый соус", amount: "2,5 ст. л." },
            { name: "Растительное масло", amount: "2 ст. л." },
            { name: "Пищевые дрожжи (опционально)", amount: "2,5 ст. л." },
            { name: "Чесночный порошок, копчёная паприка", amount: "по вкусу" },
        ],
        steps: [
            "Тофу отпрессуйте, нарежьте кубиками.",
            "Смешайте маринад: соевый соус + масло + дрожжи + специи.",
            "Обваляйте кубики тофу в этой пасте.",
            "Готовьте при 200°C 12–14 мин.",
        ],
        tips: [
            "Пищевые дрожжи дают «сырный» умами-вкус — стоит попробовать хотя бы раз.",
            "Копчёная паприка даёт аромат, похожий на жареное мясо.",
        ],
    },

    "tofu-korean": {
        tags: ["airfryer", "tofu", "mainDish"],
        title: "Тофу по-корейски (острый)",
        desc: "Пикантный тофу в корейском стиле. Кочудян заменён на острый кетчуп с красным перцем.",
        time: "15–20 мин",
        temp: "180°C",
        servings: "2 порции",
        ingredients: [
            { name: "Тофу твёрдый", amount: "300 г" },
            { name: "Острый кетчуп", amount: "20 г" },
            { name: "Красный молотый перец", amount: "½ ч. л." },
            { name: "Соевый соус", amount: "2 ч. л." },
            { name: "Кунжутное масло", amount: "2 ч. л." },
            { name: "Мёд", amount: "1 ч. л." },
            { name: "Чеснок", amount: "1–2 зубчика" },
            { name: "Имбирь (тёртый)", amount: "~1 см корня" },
            { name: "Рисовый уксус или лимонный сок", amount: "2 ч. л." },
            { name: "Кунжут, зелёный лук", amount: "для подачи" },
        ],
        steps: [
            "Тофу отпрессуйте, нарежьте кубиками.",
            "Смешайте все ингредиенты маринада (кроме кунжута и лука). Замаринуйте тофу на 10–15 мин.",
            "Готовьте при 180°C 15–20 мин.",
            "Посыпьте кунжутом и зелёным луком при подаче.",
        ],
        tips: [
            "Оригинал делается с кочудяном — если найдёте, замените кетчуп + перец на 20 г пасты.",
            "Рисовый уксус можно заменить лимонным соком в том же количестве.",
        ],
    },

    "tofu-green-beans": {
        tags: ["airfryer", "tofu", "mainDish"],
        title: "Тофу с зелёной фасолью в соусе чили",
        desc: "Полноценное блюдо с хрустящим тофу и стручковой фасолью в кисло-сладком соусе чили.",
        time: "20–25 мин",
        temp: "200°C",
        servings: "2–3 порции",
        ingredients: [
            { name: "Тофу твёрдый", amount: "400 г" },
            { name: "Зелёная (стручковая) фасоль", amount: "450 г" },
            { name: "Оливковое масло (рафинированное)", amount: "2 ст. л." },
            { name: "Соевый соус", amount: "⅓ стакана" },
            { name: "Яблочный уксус (замена рисовому)", amount: "2 ст. л." },
            { name: "Мирин или сахарный сироп", amount: "2 ст. л." },
            { name: "Сахар (коричневый или белый)", amount: "1 ст. л." },
            { name: "Чесночная паста чили или острый кетчуп + ½ ч. л. перца", amount: "1 ч. л." },
            { name: "Кукурузный крахмал", amount: "1 ч. л." },
        ],
        steps: [
            "Тофу отпрессуйте, нарежьте ломтиками. Зелёную фасоль промойте, обрежьте кончики.",
            "Смешайте тофу и фасоль с маслом, выложите в корзину аэрогриля.",
            "Запекайте при 200°C 10–12 мин, встряхнув корзину в середине.",
            "Смешайте соевый соус, уксус, мирин/сироп, сахар, пасту чили и крахмал (разведённый в 1 ст. л. холодной воды) в маленькой кастрюле.",
            "Прогревайте соус на среднем огне, помешивая, до загустения (~2 мин).",
            "Залейте готовый тофу с фасолью соусом, аккуратно перемешайте.",
        ],
        tips: [
            "Мирин можно заменить: 1,5 ст. л. сахарного сиропа + ½ ст. л. белого вина или просто добавить чуть больше сахара.",
            "Рисовый уксус заменяется яблочным 1:1.",
            "Крахмал всегда разводите в холодной воде перед добавлением в соус.",
        ],
    },

    "tofu-salt-pepper": {
        tags: ["airfryer", "tofu", "snack"],
        title: "Тофу «Соль, перец, масло»",
        desc: "Минимум ингредиентов — максимум хруста. Идеальная закуска или гарнир.",
        time: "10–15 мин",
        temp: "200°C",
        servings: "2 порции",
        ingredients: [
            { name: "Тофу твёрдый", amount: "400 г" },
            { name: "Кукурузный крахмал", amount: "1 ст. л." },
            { name: "Соль", amount: "0,5 ч. л." },
            { name: "Чёрный перец (или смесь с чесночным порошком)", amount: "0,5 ч. л." },
            { name: "Растительное масло", amount: "1 ст. л." },
        ],
        steps: [
            "Тофу отпрессуйте, нарежьте кубиками.",
            "Смешайте крахмал, соль и перец. Обваляйте тофу.",
            "Сбрызните маслом.",
            "Готовьте при 200°C 10–15 мин, перевернув кусочки на середине.",
        ],
        tips: [
            "Подавайте с соевым соусом или любым дипом.",
            "Добавьте копчёную паприку для аромата.",
        ],
    },

    "tofu-garlic-soy": {
        tags: ["airfryer", "tofu", "snack", "mainDish"],
        title: "Тофу с чесноком и соевым соусом",
        desc: "Базовый рецепт с двумя вариантами: маринование до запекания или глазурь после.",
        time: "10–15 мин",
        temp: "200°C",
        servings: "2 порции",
        ingredients: [
            { name: "Тофу твёрдый", amount: "400 г" },
            { name: "Соевый соус", amount: "2 ст. л." },
            { name: "Чеснок", amount: "2 зубчика" },
            { name: "Кунжутное масло (или подсолнечное)", amount: "1 ч. л." },
            { name: "Крахмал (по желанию)", amount: "1 ч. л." },
        ],
        steps: [
            "Тофу отпрессуйте, нарежьте кубиками.",
            "Вариант A (маринованный): смешайте соевый соус, чеснок, масло. Залейте тофу, оставьте 5–10 мин. При желании обваляйте в крахмале. Готовьте при 200°C 10–15 мин, встряхнув один раз.",
            "Вариант Б (соус после): сбрызните тофу маслом и готовьте при 200°C 10–15 мин без соуса — так хруст максимальный. Пока жарится, проварите соевый соус + чеснок + масло + 1 ст. л. воды 1 мин. Полейте готовый тофу.",
        ],
        tips: [
            "Вариант Б даёт более хрустящую корочку — соус не размягчает её при запекании.",
            "Вариант А — проще и быстрее, вкус глубже проникает в тофу.",
        ],
    },
};

